import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="px-4 md:px-10 py-20 md:py-28 flex flex-col items-center justify-center text-center min-h-[70vh]">
      <p className="font-heading text-7xl md:text-9xl font-bold text-background-200 select-none">404</p>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">页面未找到</h1>
      <p className="mt-3 text-sm text-foreground-500">
        你访问的页面不存在或已被移动：<span className="font-mono text-foreground-600">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-label text-background-50 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/episodes"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-label text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-film-line" />
          浏览剧集章节
        </Link>
      </div>
    </div>
  );
}